import React, { useEffect, useState } from 'react';
import BbsListComponent from './BbsListComponent';
import { withRouter, Link } from 'react-router-dom';
import queryString from 'query-string';
import * as BbsService from '../../../services/Bbs.service';
import * as ListHelper from '../../../helpers/List.helper';
import stripHtml from 'string-strip-html';

const BbsListContainer = props => {

    const [list, setList] = useState([]);
    const [bbsType, setBbsType] = useState('');
    const [bbsTitle, setBbsTitle] = useState('');
    const [bbsClassName, setBbsClassName] = useState('');
    const [listClassName, setListClassName] = useState('');

    const [codeList, setCodeList] = useState([]);
    const [page, setPage] = useState(1);
    const [paginationObj, setPaginationObj] = useState(null);
    const [hasNextPage, setHasNextPage] = useState(false);

    useEffect(_ => {
        const init = async page => {
            console.log('props', props);

            let codeList = [];
            // Story & News
            if (props.match.path.indexOf('stories-news') >= 0) {
                codeList = ['SN-STORY', 'SN-NEWS'];
                setBbsType('');
                setBbsTitle('STORIES & NEWS');
                setBbsClassName('story-news');
                setListClassName('bbs-list');
            } else if (props.match.path.indexOf('story') >= 0) {
                codeList = ['SN-STORY'];
                setBbsType('story');
                setBbsTitle('STORIES & NEWS');
                setBbsClassName('story-news');
                setListClassName('bbs-list');
            } else if (props.match.path.indexOf('news') >= 0) {
                codeList = ['SN-NEWS'];
                setBbsType('news');
                setBbsTitle('STORIES & NEWS');
                setBbsClassName('story-news');
                setListClassName('bbs-list');
            }
            // New Material & Production
            else if (props.match.path.indexOf('new-material-production') >= 0) {
                codeList = ['NMP-NEW_MATERIALS', 'NMP-PRODUCTION'];
                setBbsType('');
                setBbsTitle('NEW MATERIAL & PRODUCTION');
                setBbsClassName('new-material-production');
                setListClassName('grid-list');
            } else if (props.match.path.indexOf('new-material') >= 0) {
                codeList = ['NMP-NEW_MATERIALS'];
                setBbsType('new-material');
                setBbsTitle('NEW MATERIAL & PRODUCTION');
                setBbsClassName('new-material-production');
                setListClassName('grid-list');
            } else if (props.match.path.indexOf('production') >= 0) {
                codeList = ['NMP-PRODUCTION'];
                setBbsType('production');
                setBbsTitle('NEW MATERIAL & PRODUCTION');
                setBbsClassName('new-material-production');
                setListClassName('grid-list');
            }
            setCodeList(codeList);


            let { totalCount, list, hasNextPage } = await BbsService.getList(page, codeList)
            for (let i = 0; i < list.length; i++) {
                list[i].context = stripHtml(list[i].context).result;
            }
            let paginationObj = ListHelper.makePaginationObj(totalCount, page, 10, 10);

            console.log('hasNextPage', hasNextPage);
            setHasNextPage(hasNextPage);
            setPage(page);
            setPaginationObj(paginationObj)
            setList(list);
        }

        let params = queryString.parse(props.location.search);
        let page = parseInt(params['page'] ? params['page'] : 1);
        init(page)
    }, [props])

    const onClickArticle = (id) => {
        const url = `${props.match.path}/${id}`;
        props.history.push(url);
    }

    const onClickBtnPageNum = (pageNum) => {
        const url = `${props.match.path}?page=${pageNum}`;
        props.history.push(url)
    }

    const onClickBtnMobileMore = async () => {
        const newPage = page + 1;
        let result = await BbsService.getList(newPage, codeList)

        for (let i = 0; i < result.list.length; i++) {
            result.list[i].context = stripHtml(result.list[i].context).result;
        }
        let paginationObj = ListHelper.makePaginationObj(result.totalCount, newPage, 10, 10);

        const newList = list.concat(result.list);
        newList.concat(list);
        console.log('newList', newList);

        console.log('hasNextPage', result.hasNextPage);
        setHasNextPage(result.hasNextPage);
        setPage(newPage);
        setPaginationObj(paginationObj)
        setList(newList);
    }

    return (
        <BbsListComponent
            list={list}
            bbsTitle={bbsTitle}
            bbsType={bbsType}
            bbsClassName={bbsClassName}
            listClassName={listClassName}
            paginationObj={paginationObj}
            onClickArticle={onClickArticle}
            onClickBtnPageNum={onClickBtnPageNum}
            hasNextPage={hasNextPage}
            onClickBtnMobileMore={onClickBtnMobileMore}
            {...props}
        />
    )
}

export default withRouter(BbsListContainer);